import { ChangeEvent } from 'react';

export const processUploadFileEvent = (
  event: ChangeEvent<HTMLInputElement>,
  exts: string,
  callback: (file: File) => void
) => {
  const files = event.currentTarget.files;

  if (files) {
    const file = files[0];
    const ext = file.name.split('.').pop() ?? '';

    if (exts.includes(ext)) {
      callback(file);
    }
  }

  event.target.value = '';
};
